import { Navigate, useLocation } from 'react-router-dom';

interface OAuthRedirectHandlerProps {
  children: React.ReactNode;
}

/**
 * Handles OAuth redirects that land on the wrong URL.
 * If we detect an OAuth code in the URL params, redirect to the proper callback.
 * This check happens synchronously before rendering children.
 */
export function OAuthRedirectHandler({ children }: OAuthRedirectHandlerProps) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get('code');

  // If there's an OAuth code on the root path, redirect to callback immediately
  if (code && location.pathname === '/') {
    return <Navigate to={`/auth/callback${location.search}`} replace />;
  }

  return <>{children}</>;
}
